import './Bitacoras.scss'
import React, {useEffect, useRef, useState} from "react";
import {getUnitsReport} from "./Bitacoras.service";
import {Button} from "primereact/button";
import InputCalendario from "../../../components/atoms/InputCalendario/InputCalendario";
import {UpdateValue} from "../../../utilidades/Validaciones";
import {Toolbar} from "primereact/toolbar";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import BotonDescargarExel from "../../../components/atoms/BotonDescargarExel/BotonDescargarExel";

const Bitacoras = () => {
    const [unitGlobalFilters, setUnitGlobalFilters] = useState('');
    const [unitsReport, setUnitsReport] = useState([]);
    const [dateFilters, setDateFilters] = useState({
        start: {value: new Date(new Date().getFullYear(), new Date().getMonth(), 1)},
        end: {value: new Date()}
    });

    // =========== REFS ===========
    const table = useRef(null);

    // =========== COMPONENT TEMPLATES ===========
    const header = (
        <InputText
            type="search"
            value={unitGlobalFilters}
            onChange={(e) => setUnitGlobalFilters(e.target.value)}
            placeholder="Buscar"
            className='buscador'
            size="50"/>
    );

    // =========== EFFECTS ===========
    useEffect(() => {
        getUnitsReport(setUnitsReport, dateFilters);
    }, [dateFilters]);

    const unitDataFiltered = unitsReport.filter(row =>
        Object.values(row).some(value =>
            String(value).toLowerCase().includes(unitGlobalFilters.toLowerCase())
        )
    );


    const rightToolbarTemplate = () => {
        return <BotonDescargarExel nombreArchivo="Reporte bitacoras por unidad" datos={unitsReport}/>
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <div className='fila'>
                    <div className="columna">
                        <InputCalendario value={dateFilters.start.value} id={"start"}
                                         onChange={(e) => {
                                             UpdateValue(e, "start", dateFilters, setDateFilters)
                                         }} titulo={"Fecha de Inicio"}></InputCalendario>
                    </div>
                    <div className="columna">
                        <InputCalendario value={dateFilters.end.value} id={"end"}
                                         onChange={(e) => {
                                             UpdateValue(e, "end", dateFilters, setDateFilters)
                                         }} titulo={"Fecha de Fin"}></InputCalendario>
                    </div>
                </div>
            </>

        )
    }


    return (
        <>
            <div className="card">
                <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                <DataTable value={unitDataFiltered}
                           header={header}
                           globalFilter={unitGlobalFilters}
                           showGridlines
                           scrollable
                           scrollHeight="calc(100vh - 290px)"
                           size='small'
                           paginator
                           paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                           rows={50}
                           rowsPerPageOptions={[50, 100, 200]}>
                    <Column field='ID' header="ID"/>
                    <Column field="DESCRIPCION" header="DESCRIPCION"/>
                    <Column field="BITACORAS_REALIZADAS" header="BITACORAS REALIZADAS"/>
                    <Column field="ULTIMA_BITACORA" header="ULTIMA BITACORA"/>
                </DataTable>
            </div>
        </>
    )


}

export default Bitacoras
